import type { DocumentModerationModalRootContainerProps } from '@jusbrasil-rc/document-moderation-modal'
import { useFrameBusClient } from '@jusbrasil-web/shared-frame-bus'
import { useCallback, useState } from 'react'

import { DOCUMENT_MODERATION_MODAL_IFRAME_URL } from '../constants'

const FRAME_BUS_ID = 'document-moderation-modal'

export interface UseDocumentModerationModalReturn {
  ready: boolean
  loading: boolean
  init: () => void
  open: (props: DocumentModerationModalRootContainerProps) => void
}

export const useDocumentModerationModal = (): UseDocumentModerationModalReturn => {
  const [enabled, setEnabled] = useState(false)
  const [ready, setReady] = useState(false)

  const frame = useFrameBusClient({
    id: FRAME_BUS_ID,
    src: DOCUMENT_MODERATION_MODAL_IFRAME_URL,
    enabled,
    onConnect() {
      setReady(true)
    },
    onReconnect() {
      frame.close()
    },
    onPopstate() {
      frame.close()
    },
  })

  const openModal = useCallback(() => {
    frame.open()
    // focus on the iframe content
    // timeout is necessary due to the dropdown tries to stealing the focus
    setTimeout(() => frame.ref.current?.focus(), 100)
  }, [frame])

  return {
    ready,
    loading: enabled && !ready,
    init() {
      setEnabled(true)
    },
    open(props: DocumentModerationModalRootContainerProps) {
      if (enabled && ready) {
        frame.trigger('setProps', props)
        openModal()
      }
    },
  }
}
